 <i *ngIf="errors" class="wm-icon error wms wms-error-outline" title="{{locale.MESSAGE_ERROR_INVALID_INPUT_DESC}}"></i>
  <div class="multi-property-field">
    <div class="top">
      <input type="text" [attr.data-identifier]="'property-'+property+'top'" class="app-textbox"
             ng-model-options="{updateOn: 'blur change'}"
             [(ngModel)]="_model.top"
             (focus)="setActiveProperty(property)"
             (change)="_onChange('top', _model.top)"
             [ngClass]="{'invalid-input-box': _errors.top}"/>
    </div>
    <div class="middle">
      <input type="text" [attr.data-identifier]="'property-'+property+'left'" class="app-textbox app-left"
             ng-model-options="{updateOn: 'blur change'}"
             [(ngModel)]="_model.left"
             (focus)="setActiveProperty(property)"
             (change)="_onChange('left', _model.left)"
             [ngClass]="{'invalid-input-box': _errors.left}"/>
      <span class="{{property}}-icon icon"></span>
      <input type="text" [attr.data-identifier]="'property-'+property+'right'" class="app-textbox app-right"
             ng-model-options="{updateOn: 'blur change'}"
             [(ngModel)]="_model.right"
             (focus)="setActiveProperty(property)"
             (change)="_onChange('right', _model.right)"
             [ngClass]="{'invalid-input-box': _errors.right}"/>
    </div>
    <div class="bottom">
      <input type="text" [attr.data-identifier]="'property-'+property+'bottom'" class="app-textbox"
             ng-model-options="{updateOn: 'blur change'}"
             [(ngModel)]="_model.bottom"
             (focus)="setActiveProperty(property)"
             (change)="_onChange('bottom', _model.bottom)"
             [ngClass]="{'invalid-input-box': _errors.bottom}"/>
    </div>
  </div>

  <div class="property-template toggle-property property-wrapper" *ngIf="!isNativeMobileApplicationType">
            <span *ngIf="property !== 'borderwidth'">
                <input type="radio" [attr.data-identifier]="'property-'+property+'unit%'" class="%-icon property-radio percentageicon"
                       name="{{property}}unit" id="{{property}}unit %"
                       [(ngModel)]="_model.unit" value="%"
                       (change)="_onUnitChange()"/>
                <label class="radiotemplate-label"
                       title="{{locale['LABEL_PROPERTY_' + property.toUpperCase()] || property}}{{locale.LABEL_PROPERTY_PADDINGUNIT}} %"
                       for="{{property}}unit %">%</label>
            </span>
    <span>
                <input type="radio" [attr.data-identifier]="'property-'+property+'unitem'" class="em-icon property-radio"
                       name="{{property}}unit" id="{{property}}unit em"
                       [(ngModel)]="_model.unit" value="em"
                       (change)="_onUnitChange()"/>
                <label class="radiotemplate-label"
                       title="{{locale['LABEL_PROPERTY_' + property.toUpperCase()] || property}}{{locale.LABEL_PROPERTY_PADDINGUNIT}} em"
                       for="{{property}}unit em">em</label>
            </span>
    <span>
                <input type="radio" [attr.data-identifier]="'property-'+property+'unitpx'" class="px-icon property-radio"
                       name="{{property}}unit" id="{{property}}unit px"
                       [(ngModel)]="_model.unit" value="px"
                       (change)="_onUnitChange()"/>
                <label class="radiotemplate-label"
                       title="{{locale['LABEL_PROPERTY_' + property.toUpperCase()] || property}}{{locale.LABEL_PROPERTY_PADDINGUNIT}} px"
                       for="{{property}}unit px">px</label>
            </span>
    <span>
                <input type="radio" [attr.data-identifier]="'property-'+property+'unitpt'" class="pt-icon property-radio"
                       name="{{property}}unit" id="{{property}}unit pt"
                       [(ngModel)]="_model.unit" value="pt"
                       (change)="_onUnitChange()"/>
                <label class="radiotemplate-label"
                       title="{{locale['LABEL_PROPERTY_' + property.toUpperCase()] || property}}{{locale.LABEL_PROPERTY_PADDINGUNIT}} pt"
                       for="{{property}}unit pt">pt</label>
            </span>
  </div>
